import {
  Button,
  Checkbox,
  Text,
  FormControl,
  FormLabel,
  Center,
  Input,
  Box,
  Stack,
  InputGroup,
  InputRightElement,
  InputLeftElement,
  Image,
  useToast,
  Flex,
} from "@chakra-ui/react";

//react imports
import { useState, useContext } from "react";

//react-icons imports
import { BsArrowRightShort } from "react-icons/bs";

//auth import
import { EmailIcon, PhoneIcon } from "@chakra-ui/icons";
import { loginAPI, userRegistrationAPI } from "../../Utils/api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../Utils/auth";
import { break_logo_dark, fj_logo } from "../../theme";

const SignupNoOtp = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const toast = useToast();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const { customLink } = useParams();
  const dynamicUrl = customLink || "break_admin-admin-1";
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  const getLogin = async () => {
    setLoading(true);
    try {
      const res = await loginAPI(email, password);
      if (res.error) {
        toast({
          title: "Login Failed",
          description: res.error,
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      } else {
        authCtx.login(res.data.token, res.data.email, res.data.name);
        window.location = "/";
      }
    } catch (error) {
      console.error(error);
      toast({
        title: "Login Failed",
        description: "An unexpected error occurred during login.",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const createAccount = async () => {
    setLoading(true);
    try {
      const additionalData =
        location.pathname === "/qva8nj9czdh8"
          ? { campaign: "gift_of_bpm" }
          : {};
      const payload = {
        email,
        password,
        name,
        phone,
        dynamicUrl,
        additionalData,
      };
      const signupRes = await userRegistrationAPI(payload);
      if (signupRes.status === "success") {
        toast({
          title: "Account Created successfully.",
          description: signupRes.message,
          status: "success",
          position: "top-right",
          duration: 2000,
          isClosable: true,
        });
        getLogin();
      } else {
        handleSignupError(signupRes);
      }
    } catch (error) {
      console.error(error);
      handleSignupError(error);
    } finally {
      setLoading(false);
    }
  };
  const handleSignupError = (error) => {
    console.error("Error during signup:", error);
    toast({
      title: "Signup Failed.",
      description: "An unexpected error occurred during signup.",
      status: "error",
      position: "top-right",
      duration: 2000,
      isClosable: true,
    });
  };

  const handleChange = (event, setStateFunction) => {
    const { type, checked, value } = event.target;
    setStateFunction(type === "checkbox" ? checked : value);
  };

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      py={["4", "6"]}
      px={["4", "6"]}
      minH="100vh"
      flexDir="column"
    >
      <Box position="relative">
        <Flex
          style={{ borderWidth: "1px", borderRadius: "10px" }}
          border="1px solid black"
          flexDir="column"
          p={["4", "5"]}
          gap="4"
          w={["95%", "90%", "80%", "xl"]}
          maxW="xl"
        >
          <Center>
            <Image
              src={fj_logo}
              width="auto"
              height={["8vh", "10vh", "12vh"]}
              objectFit="contain"
            />
          </Center>
          <Box>
            <Text fontSize={["20px", "22px", "24px"]} fontWeight={700}>
              Create Account
            </Text>
            <Text fontSize={["12px", "13px", "14px"]} color={"#717171"}>
              Let's get started with your Brain Pattern Mapping.
            </Text>
          </Box>

          <Stack spacing={[3, 4]}>
            <FormControl isRequired id="name">
              <FormLabel fontSize={["14px", "15px", "16px"]}>
                Full Name
              </FormLabel>
              <Input
                size={["sm", "md"]}
                type="text"
                placeholder="Enter your name"
                value={name}
                onChange={(event) => handleChange(event, setName)}
              />
            </FormControl>

            <FormControl isRequired id="email">
              <FormLabel fontSize={["14px", "15px", "16px"]}>
                Email Address
              </FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <EmailIcon color="gray.300" />
                </InputLeftElement>
                <Input
                  size={["sm", "md"]}
                  type="email"
                  placeholder="Enter your Email Address"
                  value={email}
                  onChange={(event) => handleChange(event, setEmail)}
                />
              </InputGroup>
            </FormControl>

            <FormControl isRequired id="phone">
              <FormLabel fontSize={["14px", "15px", "16px"]}>
                Phone Number
              </FormLabel>
              <InputGroup size={["sm", "md"]}>
                <InputLeftElement pointerEvents="none">
                  <PhoneIcon color="gray.300" />
                </InputLeftElement>
                <Input
                  type="tel"
                  placeholder="Enter your Phone Number"
                  value={phone}
                  onChange={(event) => handleChange(event, setPhone)}
                />
              </InputGroup>
            </FormControl>

            <FormControl isRequired id="password">
              <FormLabel fontSize={["14px", "15px", "16px"]}>
                Enter Password
              </FormLabel>
              <InputGroup size={["sm", "md"]}>
                <Input
                  pr="4.5rem"
                  type={show ? "text" : "password"}
                  placeholder="At least 8 characters long"
                  value={password}
                  onChange={(event) => handleChange(event, setPassword)}
                />
                <InputRightElement width="4.5rem">
                  <Button
                    h={["1.5rem", "1.75rem"]}
                    size="sm"
                    onClick={handleClick}
                  >
                    {show ? "Hide" : "Show"}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>

            <Checkbox
              color={"rgba(0, 0, 0, 0.50)"}
              m={"6px 0 6px 0"}
              letterSpacing={"-0.14px"}
              fontSize={["12px", "13px", "14px"]}
              onChange={(event) => handleChange(event, setIsChecked)}
            >
              I agree to all
              <Text as={"span"} color={"black"}>
                {" "}
                Terms{" "}
              </Text>
              and the
              <Text as={"span"} color={"black"}>
                {" "}
                Privacy Policy
              </Text>
              .
            </Checkbox>

            <Button
              size={["sm", "md"]}
              bg="black"
              color="white"
              onClick={createAccount}
              rightIcon={<BsArrowRightShort />}
              isLoading={loading}
              mt={["16px", "20px"]}
              isDisabled={!email || !password || !name || !isChecked}
              _hover={{
                bg: "gray",
              }}
              _disabled={{
                bg: "black",
                cursor: "not-allowed",
              }}
            >
              Create my account
            </Button>
          </Stack>

          <Stack spacing={[3, 4]}>
            <Text fontSize={["14px", "15px", "16px"]}>
              Already have an account?{" "}
              <Text
                onClick={() => {
                  navigate("/login");
                }}
                cursor="pointer"
                as={"span"}
                color={"black"}
                fontWeight="600"
              >
                Login here.
              </Text>
            </Text>
          </Stack>
        </Flex>
        <Box
          position="absolute"
          top="100%"
          left="50%"
          transform="translate(-50%, 20px)"
          width="100%"
        >
          <Flex alignItems="center" justify="center" gap="12px">
            <Text
              color="black"
              fontSize={["12px", "12px", "12px", "14px", "14px"]}
              mb="5px"
            >
              POWERED BY
            </Text>
            <Image
              src={break_logo_dark}
              alt="Logo"
              width={["120px", "150px", "200px", "200px", "200px"]}
            />
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default SignupNoOtp;
